module.exports = __webpack_public_path__ + "img/Bent Link B.38416d73.png";